import concreteCalculator from '../calculators/concrete'
import shinglesCalculator from '../calculators/shingles'
import carpetCalculator from '../calculators/carpet'
import drywallCalculator from '../calculators/drywall'
import lumberCalculator from '../calculators/lumber'

export default function calculator (document, moduleHTML, appEventEmitter) {
  const calculatorType = moduleHTML.dataset.jsCalculator
  const calculatorForm = moduleHTML.getElementsByTagName('form')[0]
  const calculatorEstimatedWeightPanel = moduleHTML.querySelector('[data-js-calculator-estimated-weight-panel]')
  const calculatorResultsPanel = moduleHTML.querySelector('[data-js-calculator-results]')
  const calculatorResetButton = moduleHTML.querySelector('[data-js-calculator-reset-button]')
  const calculatorRecommendedDumpsterTitle = moduleHTML.querySelector('[data-js-calculator-recommended-title]')
  const calculatorRecommendedDumpsterImage = moduleHTML.querySelector('[data-js-calculator-recommended-image]')

  calculatorResetButton.addEventListener('click', handleReset)

  switch (calculatorType) {
    case 'concrete':
      concreteCalculator(calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults)
      break
    case 'shingles':
      shinglesCalculator(calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults)
      break
    case 'carpet':
      carpetCalculator(calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults)
      break
    case 'drywall':
      drywallCalculator(calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults)
      break
    case 'lumber':
      lumberCalculator(calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults)
      break
  }

  function toggleResults () {
    calculatorForm.classList.toggle('hidden')
    calculatorForm.classList.toggle('flex')
    calculatorEstimatedWeightPanel.style.transform = 'translateY(76px)'
    calculatorEstimatedWeightPanel.classList.toggle('invisible')
    calculatorResultsPanel.classList.toggle('flex')
    calculatorResultsPanel.classList.toggle('hidden')
  }

  function handleReset () {
    toggleResults()
    calculatorEstimatedWeightPanel.style.transform = ''
  }
}
